import {createFeatureSelector, createSelector} from '@ngrx/store';
import {QueryResultsModel} from '../_base/crud';
import {selectAllUsers, UsersState} from '../reducers/user.reducers';

export const selectUsersState = createFeatureSelector<UsersState>('users');

export const selectUserById = (userId: number) => createSelector(
    selectUsersState,
    usersState => usersState.entities[userId]
);

export const selectUsersPageLoading = createSelector(
    selectUsersState,
    usersState => usersState.listLoading
);

export const selectUsersActionLoading = createSelector(
    selectUsersState,
    usersState => usersState.actionsLoading
);

export const selectLastCreatedUserId = createSelector(
    selectUsersState,
    usersState => usersState.lastCreatedUserId
);

export const selectLastUpdatedUserId = createSelector(
    selectUsersState,
    usersState => usersState.lastUpdatedUserId
);

export const selectLastUserError = createSelector(
    selectUsersState,
    usersState => ({error_code: usersState.error_code, message: usersState.error_message})
);

export const selectUsersInStore = () => createSelector(
    selectUsersState,
    usersState => {
        const items = selectAllUsers(usersState);
        return new QueryResultsModel(items, usersState.totalCount, [], '');
    }
);

export const selectProjectUsers = () => createSelector(
    selectUsersState,
    usersState => {
        const items = selectAllUsers(usersState);
        return new QueryResultsModel(items, usersState.totalCount, [], '');
    }
);

export const selectUsersShowInitWaitingMessage = createSelector(
    selectUsersState,
    usersState => usersState.showInitWaitingMessage
);

export const selectHasUsersInStore = createSelector(
    selectUsersState,
    queryResult => queryResult.totalCount
);
